import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { io, Socket } from 'socket.io-client';

interface SocketContextType {
  socketInstance: Socket | null;
  connectSocket: (userUUID: string) => void;
  disconnectSocket: () => void;
  makeUserOnline: () => void;
}
const SocketContext = createContext<SocketContextType | undefined>(undefined);

interface SocketProviderProps {
  children: ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const [socketInstance, setSocketInstance] = useState<Socket | null>(null);

  const connectSocket = (userUUID: string) => {
    if (socketInstance) {
      return;
    }

    const validUserUUID = userUUID || sessionStorage.getItem('userUUID');

    if (!validUserUUID) {
      return;
    }

    let socket;

    const key = sessionStorage.getItem('key');
    if (key === 'User') {
      socket = io(process.env.REACT_APP_SOCKET_URL, {
        auth: {
          Key: 'User',
          uuid: validUserUUID
        },
        transports: ['websocket']
      });
    } else if (key === 'Vendor') {
      socket = io(process.env.REACT_APP_SOCKET_URL, {
        auth: {
          Key: 'Vendor',
          uuid: validUserUUID
        },
        transports: ['websocket']
      });
    }

    if (socket) {
      setSocketInstance(socket);
    }
  };

  const disconnectSocket = () => {
    if (socketInstance) {
      socketInstance.disconnect();
      setSocketInstance(null);
    }
  };

  const makeUserOnline = () => {
    if (socketInstance) {
      const accountUUID = sessionStorage.getItem('companyUuid');
      const userUUID = sessionStorage.getItem('userUUID');
      const payload = {
        userUuid: userUUID ? userUUID : '',
        accountUuid: accountUUID
      };
      socketInstance.emit('make-user-online', payload);
    }
  };

  useEffect(() => {
    const userUUID = sessionStorage.getItem('userUUID');
    if (userUUID) {
      connectSocket(userUUID);
    }

    return () => {
      if (socketInstance) {
        socketInstance.disconnect();
      }
    };
  }, []);
  return (
    <SocketContext.Provider
      value={{ socketInstance, connectSocket, disconnectSocket, makeUserOnline }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = (): SocketContextType => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};
